import { render, staticRenderFns } from "./ExternalSeriesTable.vue?vue&type=template&id=a490d42e&scoped=true&"
import script from "./ExternalSeriesTable.vue?vue&type=script&lang=js&"
export * from "./ExternalSeriesTable.vue?vue&type=script&lang=js&"
import style0 from "./ExternalSeriesTable.vue?vue&type=style&index=0&id=a490d42e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a490d42e",
  null
  
)

export default component.exports